import { render, staticRenderFns } from "./wty-permission.vue?vue&type=template&id=18567298&scoped=true&"
import script from "./wty-permission.vue?vue&type=script&lang=js&"
export * from "./wty-permission.vue?vue&type=script&lang=js&"
import style0 from "./wty-permission.vue?vue&type=style&index=0&id=18567298&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18567298",
  null
  
)

export default component.exports